export const gotoLink = (link) => {
  window.open(link);
};
